export const actionTypes = {
  FETCH_NOTIFICATIONS: 'FETCH_NOTIFICATIONS',
  FETCH_NOTIFICATIONS_SUCCESS: 'FETCH_NOTIFICATIONS_SUCCESS',
  FETCH_NOTIFICATIONS_FAILURE: 'FETCH_NOTIFICATIONS_FAILURE',
  FETCH_GROUPS_UNREAD_STATUS: 'NOTIFICATION_FETCH_GROUPS_UNREAD_STATUS',
  FETCH_UNREAD_STATUS: 'NOTIFICATION_FETCH_UNREAD_STATUS',
  FETCH_UNREAD_STATUS_SUCCESS: 'NOTIFICATION_FETCH_UNREAD_STATUS_SUCCESS',
  SET_ACTIVE_GROUP: 'NOTIFICATION_SET_ACTIVE_GROUP',
  SET_PANEL_OPEN: 'SET_NOTIFICATION_PANEL_OPEN',
  SET_HAS_NEW_NOTIFICATION: 'SET_HAS_NEW_NOTIFICATION',
  MARK_READ: 'NOTIFICATION_MARK_READ',
  MARK_READ_SUCCESS: 'NOTIFICATION_MARK_READ_SUCCESS',
  MARK_ALL_READ: 'NOTIFICATION_MARK_ALL_READ',
  MARK_ALL_READ_SUCCESS: 'NOTIFICATION_MARK_ALL_READ_SUCCESS',
  RECEIVE_NOTIFICATION: 'RECEIVE_NOTIFICATION',
};

export const fetchNotifications = ({
  groupCode,
  cursor,
  isLoadMore = false,
}) => ({
  type: actionTypes.FETCH_NOTIFICATIONS,
  groupCode,
  cursor,
  isLoadMore,
});

export const fetchNotificationsSuccess = ({
  groupCode,
  data,
  hasMore,
  nextCursor,
  isLoadMore,
}) => ({
  type: actionTypes.FETCH_NOTIFICATIONS_SUCCESS,
  groupCode,
  data,
  hasMore,
  nextCursor,
  isLoadMore,
});

export const fetchNotificationsFailure = (groupCode) => ({
  type: actionTypes.FETCH_NOTIFICATIONS_FAILURE,
  groupCode,
});

export const fetchGroupsUnreadStatus = () => ({
  type: actionTypes.FETCH_GROUPS_UNREAD_STATUS,
});

export const fetchUnreadStatus = () => ({
  type: actionTypes.FETCH_UNREAD_STATUS,
});

export const fetchUnreadStatusSuccess = (unreadStatus, hasNewNotification) => ({
  type: actionTypes.FETCH_UNREAD_STATUS_SUCCESS,
  unreadStatus,
  hasNewNotification,
});

export const setActiveGroup = (group) => ({
  type: actionTypes.SET_ACTIVE_GROUP,
  group,
});

export const setPanelOpen = (isOpen) => ({
  type: actionTypes.SET_PANEL_OPEN,
  isOpen,
});

export const setHasNewNotification = (hasNew) => ({
  type: actionTypes.SET_HAS_NEW_NOTIFICATION,
  hasNew,
});

export const markRead = (notificationId) => ({
  type: actionTypes.MARK_READ,
  notificationId,
});

export const markReadSuccess = (notificationId) => ({
  type: actionTypes.MARK_READ_SUCCESS,
  notificationId,
});

export const markAllRead = (groupCode) => ({
  type: actionTypes.MARK_ALL_READ,
  groupCode,
});

export const markAllReadSuccess = (groupCode) => ({
  type: actionTypes.MARK_ALL_READ_SUCCESS,
  groupCode,
});

export const receiveNotification = ({ groupCode, notification }) => ({
  type: actionTypes.RECEIVE_NOTIFICATION,
  groupCode,
  notification,
});
